/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { MenuItemVariantDto } from './MenuItemVariantDto';
import {
    MenuItemVariantDtoFromJSON,
    MenuItemVariantDtoFromJSONTyped,
    MenuItemVariantDtoToJSON,
} from './MenuItemVariantDto';
import type { MenuSubSectionDto } from './MenuSubSectionDto';
import {
    MenuSubSectionDtoFromJSON,
    MenuSubSectionDtoFromJSONTyped,
    MenuSubSectionDtoToJSON,
} from './MenuSubSectionDto';

/**
 * 
 * @export
 * @interface MenuSectionDto
 */
export interface MenuSectionDto {
    /**
     * 
     * @type {string}
     * @memberof MenuSectionDto
     */
    sectionId: string;
    /**
     * 
     * @type {string}
     * @memberof MenuSectionDto
     */
    menuId: string;
    /**
     * 
     * @type {string}
     * @memberof MenuSectionDto
     */
    name: string;
    /**
     * 
     * @type {Array<MenuItemVariantDto>}
     * @memberof MenuSectionDto
     */
    items: Array<MenuItemVariantDto>;
    /**
     * 
     * @type {number}
     * @memberof MenuSectionDto
     */
    locationId: number;
    /**
     * 
     * @type {string}
     * @memberof MenuSectionDto
     */
    locationName: string;
    /**
     * 
     * @type {string}
     * @memberof MenuSectionDto
     */
    eposDisplayColor?: string;
    /**
     * 
     * @type {Array<MenuSubSectionDto>}
     * @memberof MenuSectionDto
     */
    subsections: Array<MenuSubSectionDto>;
}

/**
 * Check if a given object implements the MenuSectionDto interface.
 */
export function instanceOfMenuSectionDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "sectionId" in value;
    isInstance = isInstance && "menuId" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "items" in value;
    isInstance = isInstance && "locationId" in value;
    isInstance = isInstance && "locationName" in value;
    isInstance = isInstance && "subsections" in value;

    return isInstance;
}

export function MenuSectionDtoFromJSON(json: any): MenuSectionDto {
    return MenuSectionDtoFromJSONTyped(json, false);
}

export function MenuSectionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): MenuSectionDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'sectionId': json['sectionId'],
        'menuId': json['menuId'],
        'name': json['name'],
        'items': ((json['items'] as Array<any>).map(MenuItemVariantDtoFromJSON)),
        'locationId': json['locationId'],
        'locationName': json['locationName'],
        'eposDisplayColor': !exists(json, 'eposDisplayColor') ? undefined : json['eposDisplayColor'],
        'subsections': ((json['subsections'] as Array<any>).map(MenuSubSectionDtoFromJSON)),
    };
}

export function MenuSectionDtoToJSON(value?: MenuSectionDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'sectionId': value.sectionId,
        'menuId': value.menuId,
        'name': value.name,
        'items': ((value.items as Array<any>).map(MenuItemVariantDtoToJSON)),
        'locationId': value.locationId,
        'locationName': value.locationName,
        'eposDisplayColor': value.eposDisplayColor,
        'subsections': ((value.subsections as Array<any>).map(MenuSubSectionDtoToJSON)),
    };
}

